import React, {Component} from 'react'
import {Container, Form, Grid, Label, Visibility} from "semantic-ui-react";
import CustomSockJsClient from "./custom_sockjs.js";
import gdpr_flow from "./items/gdpr_flow.js";
import unicorn_flow from "./items/unicorns_items.js";
import Lo from 'lodash';
import {config} from "config.js";
import DawidMenu from "./components/menu.jsx";
import FormPath from "./components/form_path.jsx";
import {DawidButtonsBar} from "./components/buttons_bar.jsx";
import DawidHeader from "./components/header.jsx";
import DawidDisclaimer from "./components/disclaimer.jsx";
import './layout.css';
import {isRealFirstIteration, serializer} from "./items/utils.js"
import {WarningMessage} from "./utils_components.jsx";
import ItemErrorHandler from "./components/item_error_handler.jsx"
import {LoopsNavigation} from "./components/loops_navigation.jsx";
import Footer from "./components/footer.jsx";
import {Contract} from "./components/contract.jsx";
import {FORM_STYLE, Item} from "./components/item.jsx";
import {
    buildPath,
    buildSummary,
    fieldsChanged,
    getAllLoopsName,
    getParentLoopName,
    getShortLoopName,
    removeDeprecatedOptions
} from "./utils.js";
import {PreliminarySection} from "./components/preliminary_section.jsx";

const flowsList = [gdpr_flow, unicorn_flow];
const WITH_CENTER_COLUMN = 10;

const flows = {};
flowsList.map((flow) => {
    flows[flow.id] = flow
});


function checkCompleteLoop(loopName, loops) {
    let hasIncomplete = false;
    const previousLoop = loops[loopName];
    previousLoop.validIterations[previousLoop.index - 1] = true;
    for (let i = 0; i < previousLoop.validIterations.length; i++) {
        if (previousLoop.validIterations[i] === false) {
            hasIncomplete = true;
            break;
        }
    }
    if (!hasIncomplete) {
        const parentLoopName = loopName.substring(0, loopName.indexOf('#'));
        if (parentLoopName !== '') {
            return checkCompleteLoop(parentLoopName, loops);
        }
    }
    return hasIncomplete;
}


export default class StickyLayout extends Component {
    defaultState = {
        menuFixed: false,
        overlayFixed: false,
        itemsStates: {},
        clientConnected: false,
        loops: {},
        path: [],
        globals: {},
        contractGenerated: false,
        contract: '',
        contractError: false,
        emailAddress: '',
        hasErrors: false,
        largeFont: false,
        sessionCreated: false,
        showSummary: false,
        hasGlobalError: false,
        globalErrorInfo: "",
        mode: 'editor',
        canFreelyNavigate: true
    };
    state = Lo.cloneDeep(this.defaultState);

    constructor(props) {
        super(props);
        this.state = Object.assign(this.state, {
            currentFlowId: 1,
            currentFlowVersion: flows[1].version,
            currentFlowName: flows[1].name,
            currentItemId: 'pop'

        });
        this.init();
        const firstItem = flows[1].items[0];
        this.state.path = [{itemId: firstItem.id, loop: null, group: firstItem.group}];
        this.itemRef = React.createRef();
        if (firstItem.defaultValues) {
            this.state.itemsStates = {
                ...this.state.itemsStates, [firstItem.id]: {"values": firstItem.defaultValues}
            };
        }
    }

    init = () => {
        this.items = {};
        this.hasIncompleteLoop = false;
        this.sessionIdPrivate = "";
        this.sessionIdPublic = "";
        this.topics_suffix = "none";
        this.expiration = null;
        flows[this.state.currentFlowId].items.map((item) => (this.items[item.id] = item));
        this.topics = [
            // {path: '/temp-queue/new_session', onMessage: this.onSessionCreatedOrJoinedAsEditor},
            // {path: 'join_session', onMessage: this.onSessionJoined},
        ];
        this.items[this.state.currentItemId].init(this.state.itemsStates, this.state.globals, this.state.loops);


    };


    reset = () => {
        // restore the state of the app to the initial state (minus a few fields)
        // the two fields below will keep their current value
        const {clientConnected, largeFont, currentFlowId, currentFlowVersion, currentFlowName} = this.state;
        const currentItem = flows[currentFlowId].items[0];
        const currentItemId = currentItem.id;
        const keepValues = {
            clientConnected,
            largeFont,
            currentFlowId,
            currentFlowVersion,
            currentFlowName,
            currentItemId,

        }
        const newState = {...this.defaultState, ...keepValues};
        newState["path"] = [{itemId: currentItemId, loop: null, group: currentItem.group}]
        if (currentItem.defaultValues) {
            newState.itemsStates = {
                ...newState.itemsStates, [currentItem.id]: {"values": currentItem.defaultValues}
            };
        }
        this.setState(newState, () => this.init());
    };


    stickTopMenu = () => this.setState({menuFixed: true});
    unStickTopMenu = () => this.setState({menuFixed: false});
    onSubmit = () => {
        if (this.state.mode === 'observer') {
            return;
        }
        let itemsStates = {...this.state.itemsStates};
        const {globals, currentItemId} = this.state;
        const currentItem = this.items[currentItemId];
        if (itemsStates[currentItemId] === undefined) {
            itemsStates[currentItemId] = {};
        }
        // we store previous fields to detect fields changes and invalidate the values
        itemsStates[currentItemId].fields = this.items[currentItemId].fields;
        if (!('values' in itemsStates[currentItemId])) {
            // this happens when no value at all has been set in the item yet, e.g. all optional fields
            itemsStates[currentItemId]['values'] = Array(itemsStates[currentItemId].fields.length)
        }
        let loops = {...this.state.loops};
        let currentLoopName = this.items[currentItemId].loopName;
        let loopIndex;
        if (currentLoopName !== undefined) {
            loopIndex = loops[currentLoopName].index;
        }
        let nextItem = {"isDecisionNode": true, errors: []};
        let nextItemId = currentItemId;
        let previousLoopName = currentLoopName;
        let previousLoopIndex = loopIndex;
        let previousItemId = currentItemId;
        let hasErrors = false;
        if (previousLoopName !== undefined) {
            // we store previous fields to detect fields changes and invalidate the values
            const previousLoopStates = loops[previousLoopName].states[previousLoopIndex - 1];
            if (previousLoopStates[previousItemId] === undefined) {
                previousLoopStates[previousItemId] = {};
            }
            previousLoopStates[previousItemId].fields = this.items[currentItemId].fields;
            if (!('values' in previousLoopStates[previousItemId])) {
                // this happens when no value at all has been set in the item yet, e.g. all optional fields
                previousLoopStates[previousItemId]['values'] = Array(previousLoopStates[previousItemId].fields.length)
            }
            itemsStates[currentItemId] = previousLoopStates[previousItemId];
        }
        this.hasIncompleteLoop = false;
        while (nextItem.isDecisionNode && !nextItem.errors.length > 0) {
            try {
                nextItem = this.items[nextItemId].chooseNext(itemsStates, globals, loops);
            } catch (error) {
                this.setState({hasGlobalError: true, globalErrorInfo: error.message + '\n' + error.stack});
                console.error(error);
                return;
            }
            if (typeof nextItem === 'string') {
                nextItem = this.items[nextItem]
            }

            nextItem.init(itemsStates, globals, loops);
            const {loopName} = nextItem;
            if (previousLoopName !== undefined) {
                if (!this.items[previousItemId].isDecisionNode) {
                    loops[previousLoopName].states[previousLoopIndex - 1][previousItemId] = itemsStates[currentItemId];
                }
                if (previousLoopName.startsWith(loopName)) {
                    // we just finished a inner loop, mark last iteration as completed
                    const previousValidIterations = loops[previousLoopName].validIterations;
                    previousValidIterations[previousValidIterations.length - 1] = true;
                }
            }
            if (loopName !== undefined) {
                // we are in a loop
                let loop = loops[loopName];

                if (loop === undefined) {
                    let firstState = {};
                    firstState[nextItem.id] = {};
                    let loopStates = [firstState];
                    let validIterations = [false];
                    loop = {index: 1, states: loopStates, firstItemId: nextItem.id, validIterations};
                } else {
                    // we need to set all inner loops indexes to 1 when in the outer loop
                    for (const aloopName in loops) {
                        if (Object.hasOwn(loops, aloopName)) {
                            if (aloopName !== loopName && aloopName.startsWith(loopName)) {
                                loops[aloopName].index = 1;
                            }
                        }
                    }

                    if (nextItem.id === loop.firstItemId) {
                        // create or restore states object for next iteration
                        if (previousLoopName !== loopName) {
                            // we were in a different loop or not in a loop before
                            // reset index to 1
                            loop.index = 1;
                        }
                        const loopIterationState = loop.states[loop.index - 1];
                        let firstState;
                        let nextItemState;
                        if (loopIterationState !== undefined) {
                            if (loopIterationState[nextItem.id] !== undefined) {
                                nextItemState = loopIterationState[nextItem.id];
                                // for sessions that were saved before the addition of this feature
                                // TODO: can be removed later
                                if (loop.validIterations === undefined) {
                                    loop.validIterations = [false];
                                }
                            } else {
                                // we were already in this loop iteration before but without saving items
                                loopIterationState[nextItem.id] = {}
                            }
                        } else {
                            firstState = {};
                            firstState[nextItem.id] = {};
                            loop.states.push(firstState);
                            loop.validIterations.push(false);
                        }

                        itemsStates = {...itemsStates, [nextItem.id]: nextItemState}
                    }
                    if (fieldsChanged(loop.states[loop.index - 1][nextItem.id], nextItem.fields)) {
                        delete loop.states[loop.index - 1][nextItem.id];
                    }
                    // this is meant to avoid filling values from a different loop iteration
                    if (loop.states[loop.index - 1][nextItem.id] === undefined) {
                        itemsStates = {...itemsStates, [nextItem.id]: {}}
                        if (nextItem.defaultValues && !nextItem.isDecisionNode) {
                            loop.states[loop.index - 1][nextItem.id] = {values: nextItem.defaultValues}
                            itemsStates[nextItem.id] = {values: nextItem.defaultValues}
                            nextItem.validate(itemsStates, globals, loops);
                            hasErrors = nextItem.errors.length > 0;
                        }
                    }
                }
                loops[loopName] = loop;
                this.sendMessage({loop: loops[currentLoopName], loopName: currentLoopName}, '/topic/form-loop');
                this.sendMessage({loop, loopName}, '/topic/form-loop');
                previousLoopName = loopName;
                previousLoopIndex = loops[loopName].index;
                previousItemId = nextItem.id;
            }
            if (fieldsChanged(itemsStates[nextItem.id], nextItem.fields)) {
                delete itemsStates[nextItem.id];
            } else if (!nextItem.isDecisionNode && nextItem.defaultValues && itemsStates[nextItem.id] === undefined) {
                itemsStates[nextItem.id] = {values: nextItem.defaultValues}
                nextItem.validate(itemsStates, globals, loops);
                hasErrors = nextItem.errors.length > 0;
            }
            nextItemId = nextItem.id;
        }
        // if we are not in a loop anymore, we check if the previous loop was complete
        if (currentLoopName && !nextItem.loopName) {

            let hasIncomplete = checkCompleteLoop(currentLoopName, loops);
            if (hasIncomplete) {
                nextItemId = currentItemId;
                this.hasIncompleteLoop = true;
            }
        }
        let path = buildPath(this.state, currentItemId, currentItem.group, nextItemId, nextItem.loopName, nextItem.group);
        removeDeprecatedOptions(this.items[nextItemId], itemsStates, loops);
        this.setState({
            currentItemId: nextItemId,
            canFreelyNavigate: true,
            itemsStates,
            loops,
            path,
            hasErrors: hasErrors
        }, () => this.persistState());

        this.sendMessage({nextItemId, path, nextItem: serializer.serialize(nextItem)}, '/topic/form-item');

    };
    sendMessage = (msg, topic, opt_headers = {}, add_suffix = true) => {
        if (this.state.sessionCreated && add_suffix) {
            topic += '-' + this.topics_suffix
        }
        try {
            // console.log("sending message to ", {topic}, {msg});
            this.clientRef.sendMessage(topic, JSON.stringify(msg), opt_headers);
            return true;
        } catch (e) {
            return false;
        }
    };
    onSessionJoined = (msg) => {
        const {session_id_private, session_id_public, topics_suffix, state, expiration} = msg;
        this.sessionIdPrivate = session_id_private;
        this.sessionIdPublic = session_id_public;
        this.topics_suffix = topics_suffix;
        this.expiration = expiration;
        let mode = 'observer';
        if (session_id_private) {
            mode = 'editor';
        } else {
            this.topics = [
                {path: '/topic/form-value-' + this.topics_suffix, onMessage: this.onItemAttributesChanged},
                {path: '/topic/form-item-' + this.topics_suffix, onMessage: this.onItemChanged},
                {path: '/topic/form-loop-' + this.topics_suffix, onMessage: this.onLoopChanged}
            ];
        }
        if (!Lo.isEmpty(state)) {
            state.mode = mode;
            this.restoreState(state);
        } else {
            this.setState({sessionCreated: true, mode}, () => this.persistState());
        }
    };

    validation = () => {
        const {currentItemId, itemsStates, globals, loops, mode} = this.state;
        const currentItem = this.items[currentItemId];
        if (mode !== 'observer') {
            currentItem.validate(itemsStates, globals, loops);
        }
        this.setState({hasErrors: currentItem.errors.length > 0});
    };

    onItemAttributesChanged = (msg) => {
        const {itemId, fieldIndex, value, attribute} = msg;
        const loopName = this.items[itemId].loopName;
        let newValues;
        // if not a new item we update the item state
        if (loopName && (!(itemId in this.state.itemsStates) || this.state.itemsStates[itemId] === undefined)) {
            this.state.itemsStates[itemId] = this.state.loops[loopName].states[this.state.loops[loopName].index - 1][itemId];
        }
        if (itemId in this.state.itemsStates
            && this.state.itemsStates[itemId] !== undefined) {
            if (this.state.itemsStates[itemId][attribute] === undefined) {
                if (attribute === 'applyToAll') {
                    newValues = {...this.state.itemsStates[itemId], [attribute]: true};
                } else {
                    const values = Array(this.items[itemId].fields.length);
                    values[fieldIndex] = value;
                    newValues = {...this.state.itemsStates[itemId], [attribute]: values};
                }
            } else {
                let values;
                if (attribute === 'applyToAll') {
                    values = value;
                } else {
                    values = [
                        ...this.state.itemsStates[itemId][attribute].slice(0, fieldIndex),
                        value,
                        ...this.state.itemsStates[itemId][attribute].slice(fieldIndex + 1),
                    ];
                }
                newValues = {
                    ...this.state.itemsStates[itemId],
                    [attribute]: values,
                };
            }
        } else {
            let values;
            if (attribute === 'applyToAll') {
                values = value;
            } else {
                values = Array(this.items[itemId].fields.length);
                values[fieldIndex] = value;
            }
            newValues = {};
            newValues[attribute] = values
        }

        if (loopName) {
            // if in a loop, we need to update the loop state
            let validIterations;
            if (attribute === 'applyToAll') {
                validIterations = [
                    ...this.state.loops[loopName].validIterations
                ];
            } else {
                validIterations = [
                    ...this.state.loops[loopName].validIterations.slice(0, this.state.loops[loopName].index - 1),
                    false,
                    ...this.state.loops[loopName].validIterations.slice(this.state.loops[loopName].index),
                ];
            }
            this.setState({
                canFreelyNavigate: false,
                itemsStates: {
                    ...this.state.itemsStates,
                    [itemId]: newValues
                },
                loops: {
                    ...this.state.loops,
                    [loopName]: {
                        ...this.state.loops[loopName],
                        ["states"]: [
                            ...this.state.loops[loopName].states.slice(0, this.state.loops[loopName].index - 1),
                            {
                                ...this.state.loops[loopName].states[this.state.loops[loopName].index - 1],
                                [itemId]: newValues
                            },
                            ...this.state.loops[loopName].states.slice(this.state.loops[loopName].index),
                        ],
                        ["validIterations"]: validIterations
                    }
                }
            }, () => {
                attribute === 'values' && this.validation();
            });
        } else {
            this.setState({
                canFreelyNavigate: false,
                itemsStates: {
                    ...this.state.itemsStates,
                    [itemId]: newValues
                }
            }, () => {
                attribute === 'values' && this.validation();
            });
        }
    };
    onLoopChanged = (msg) => {
        const {loopName, loop, goStartLoop} = msg;
        const {loops} = this.state;
        let {path} = this.state;
        const newState = {path};
        if (loop === undefined) {
            return;
        }
        let currentItemId = this.state.currentItemId;
        let currentGroup = this.items[currentItemId].group;
        let itemId = this.state.currentItemId;
        if (goStartLoop) {
            itemId = loop.firstItemId;
        }
        const newItemStates = {
            ...this.state.itemsStates,
            [itemId]: loop.states[loop.index - 1][itemId]
        };
        const newLoops = {
            ...this.state.loops,
            [loopName]: loop
        };
        newState.itemsStates = newItemStates;
        newState.currentItemId = itemId
        // we need to set all inner loops indexes to 1 when in the outer loop
        for (const aloopName in loops) {
            if (Object.hasOwn(loops, aloopName)) {
                if (aloopName !== loopName && aloopName.startsWith(loopName)) {
                    newLoops[aloopName].index = 1;
                }
            }
        }
        newState.loops = newLoops;
        // call init to compute the fields
        this.items[itemId].init(newItemStates, this.state.globals, newLoops);
        while (this.items[itemId].isDecisionNode) {
            // handle the case where the first item of the loop is a decisionNode
            itemId = this.items[itemId].chooseNext(newItemStates, this.state.globals, newLoops).id;
            this.items[itemId].init(newItemStates, this.state.globals, newLoops);
            newItemStates[itemId] = loop.states[loop.index - 1][itemId];
            newState.currentItemId = itemId

        }
        if (goStartLoop) {
            path = buildPath(newState, currentItemId, currentGroup, itemId, loopName, this.items[itemId].group);
            newState.path = path;
        }
        // we need to recompute the path
        this.setState(newState);
    };
    basisOnChange = (msg) => {
        if (this.state.mode !== 'observer') {
            msg.itemId = this.state.currentItemId;
            this.sendMessage(msg, "/topic/form-value");
            this.onItemAttributesChanged(msg);
        }
    };

    onItemValueChange = (fieldIndex, value) => {
        const msg = {fieldIndex, value, attribute: "values"};
        this.basisOnChange(msg);
    };
    onApplyToAll = (value) => {
        const msg = {attribute: "applyToAll", value};
        this.basisOnChange(msg);
    };
    onItemPreliminaryChange = (fieldIndex, value) => {
        const msg = {fieldIndex, value, attribute: "preliminaries"};
        this.basisOnChange(msg);
    };

    onGenerateContract = () => {
        let msg;
        if (this.state.sessionCreated) {
            const session_id_public = this.sessionIdPublic;
            msg = {session_id_public};
        } else {
            msg = {state: this.state};
        }
        this.sendMessage(msg, '/queue/contract', {'reply-to': '/temp-queue/contract_created'}, false)
    };

    onItemChanged = (msg) => {
        this.hasIncompleteLoop = false;
        let {pathItem, nextItem: nextItemString, path = this.state.path} = msg;
        let nextItemId;
        if (nextItemString) {
            const nextItem = serializer.deserialize(nextItemString);
            nextItemId = nextItem.id;
            this.items[nextItemId] = nextItem;
        } else {
            nextItemId = pathItem.itemId;
        }
        const loopName = pathItem?.loop?.loopName;
        const loopIndex = pathItem?.loop?.loopIndex;
        const loopsDefinitions = flows[this.state.currentFlowId].loopsDefinitions;
        const {loops, globals} = this.state;
        if (loopName && loops[loopName]) {
            const loopsComponents = getAllLoopsName(loopName);
            for (let loopComponent of loopsComponents) {
                const indexSeparator = loopComponent.indexOf('$');
                const loopComponentName = indexSeparator === -1 ? loopComponent : loopComponent.substring(0, indexSeparator);
                const loopDefinition = loopsDefinitions[loopComponentName];
                if (loopDefinition.hasOwnProperty('restoreVariables')) {
                    loopDefinition.restoreVariables(globals);
                }

            }
            loops[loopName].index = loopIndex;
            const newItemStates = {
                ...this.state.itemsStates,
                [nextItemId]: loops[loopName].states[loopIndex - 1][nextItemId]
            };
            this.items[nextItemId].init(newItemStates, globals, loops);
            this.setState({
                currentItemId: nextItemId,
                path,
                canFreelyNavigate: true,
                hasErrors: false,
                itemsStates: newItemStates,
                loops,
                globals
            });
        } else {
            this.items[nextItemId].init(this.state.itemsStates, globals, loops);
            this.setState({
                currentItemId: nextItemId,
                canFreelyNavigate: true,
                path,
                hasErrors: false,
                hasGlobalError: false,
                globalErrorInfo: ""
            });
        }
    };
    onNavigate = (msg) => {
        // when a item is clicked on the form path
        this.sendMessage(msg, "/topic/form-item");
        if (this.state.mode !== 'observer') {
            this.onItemChanged(msg);
        }
    };
    handlePaginationLoopChange = (event, msg) => {
        const {activePage, loopName} = msg;
        const {loops} = this.state;
        const loop = loops[loopName];
        loop.index = activePage;
        let goStartLoop = false;
        this.hasIncompleteLoop = false;
        // check if we are jumping to an item that was not answered yet in this loop iteration
        // new behavior, we always go back to first item
        // if (loop.states[activePage - 1][currentItemId] === undefined) {
        goStartLoop = true;
        // }
        this.onLoopChanged({loopName, loop, goStartLoop});
    };

    changeFlow = (flowId) => {
        const items = {};

        const currentFLow = flows[flowId];
        currentFLow.items.map((item) => (this.items[item.id] = item));
        const firstItem = currentFLow.items[0];
        const path = [{itemId: firstItem.id, loop: null, group: firstItem.group}];
        this.setState({
            currentFlowId: flowId,
            items,
            currentItemId: firstItem.id,
            currentFlowVersion: currentFLow.version,
            currentFlowName: currentFLow.name,
            path,
            mode: 'editor',
            loops: {},
            itemsStates: {},
            globals: {}
        });
    };

    deleteSession() {
        const msg = {
            session_id_private: this.sessionIdPublic + "#" + this.sessionIdPrivate,
            action: 'delete'
        };
        const sent = this.sendMessage(msg, '/queue/form-persist', {}, false);
        if (sent) {
            this.reset();
        }
    };

    persistState() {
        const msg = {
            session_id_private: this.sessionIdPublic + "#" + this.sessionIdPrivate,
            state: this.state,
            action: 'save'
        };
        this.sendMessage(msg, '/queue/form-persist', {}, false);
        // localStorage.setItem("state", JSON.stringify(this.state));
    };

    restoreStateFromLocalStorage() {
        const persistedState = JSON.parse(localStorage.getItem("state"));
        this.restoreState(persistedState);
    };

    restoreState(persistedState) {
        for (let loopName in persistedState.loops) {
            if (Object.hasOwn(persistedState.loops, loopName)) {
                const loop = persistedState.loops[loopName];
                if (!'validIterations' in loop || !loop.validIterations || loop.validIterations.length === 0) {
                    loop.validIterations = Array();
                    for (let i = 0; i < loop.states.length; i++) {
                        loop.validIterations.push(true);
                    }
                }
            }
        }
        const {currentFlowId} = persistedState;
        if (currentFlowId !== undefined) {
            flows[currentFlowId].items.map((item) => {
                this.items[item.id] = item;
                if (item._buildGroupFunction) {
                    item.group = item._buildGroupFunction(persistedState.itemsStates, persistedState.globals, persistedState.loops);
                }
            });
        }
        const item = this.items[persistedState.currentItemId];
        if (item) {
            item.init(persistedState.itemsStates, persistedState.globals, persistedState.loops);
            if (item.loopName) {
                const loop = persistedState.loops[item.loopName];
                if (loop) {
                    loop.validIterations[loop.index - 1] = false;
                }
            }
        }
        this.setState(persistedState);
    };

    createSession() {
        this.sendMessage("", "/queue/form-create", {'reply-to': '/temp-queue/newsession'});
    };

    joinSession(e) {
        const {sessionIdPublic, sessionIdPrivate} = e;
        this.sendMessage({
            session_id_public: sessionIdPublic,
            session_id_private: sessionIdPrivate
        }, "/queue/form-join", {'reply-to': '/temp-queue/join_session'});
    }

    onUnhandledMessage(e) {
        const response = JSON.parse(e.body);
        if (e.headers.subscription === '/temp-queue/contract_created') {
            let contract;
            let contractError = false;
            if (response.file === 0) {
                contract = '';
                contractError = response.error;
            } else {
                contract = response.file;
            }
            this.setState({contractGenerated: true, contract, contractError});
            return;
        }

        this.onSessionJoined(response);
    }

    exportState() {
        let sessionIds;
        const itemRefInstance = this.itemRef.current;
        if (this.sessionIdPublic) {
            sessionIds = this.sessionIdPublic + "#" + this.sessionIdPrivate;
        }
        if (itemRefInstance) {
            this.state.itemsStates[this.state.currentItemId] = itemRefInstance.state;
            const loop = this.state.loops[this.items[this.state.currentItemId].loopName];
            if (loop) {
                loop.states[loop.index - 1][this.state.currentItemId] = itemRefInstance.state;
            }
        }
        const msg = {
            session_id_private: sessionIds,
            topics_suffix: this.topics_suffix,
            state: this.state,
            expiration: this.expiration
        };
        return JSON.stringify(msg);
    }

    importState(exportedState) {
        if (exportedState.session_id_private) {
            const sessionIds = exportedState.session_id_private.split('#');
            if (sessionIds.length === 2) {
                const session_id_public = sessionIds[0];
                const session_id_private = sessionIds[1];
                const topics_suffix = exportedState.topics_suffix;
                const state = exportedState.state;
                const expiration = exportedState.expiration;
                this.onSessionJoined({session_id_private, session_id_public, topics_suffix, state, expiration})
            }
        } else {
            const {currentFlowId} = exportedState.state;
            if (currentFlowId !== undefined) {
                flows[currentFlowId].items.map((item) => {
                    this.items[item.id] = item;
                    this.items[item.id] = item;
                    if (item._buildGroupFunction) {
                        item.group = item._buildGroupFunction(exportedState.state.itemsStates, exportedState.state.globals, exportedState.state.loops);
                    }
                });
            }
            const item = this.items[exportedState.state.currentItemId];
            if (item) {
                item.init(exportedState.state.itemsStates, exportedState.state.globals, exportedState.state.loops);
                if (item.loopName) {
                    const loop = exportedState.state.loops[item.loopName];
                    loop.validIterations[loop.index - 1] = false;
                }
            }
            this.setState(exportedState.state);
        }
    }

    toggleSectionPreliminary = () => {
        // mark a complete loop as preliminary
        const loopName = this.items[this.state.currentItemId].loopName;
        // check if preliminary allowed
        const friendlyLoop = flows[this.state.currentFlowId].loopsDefinitions[loopName];
        const isLoopPreliminaryAllowed = friendlyLoop?.allowPreliminary;
        if (!isLoopPreliminaryAllowed) {
            return
        }
        const loop = this.state.loops[loopName];
        if (loop.markedAsPreliminary === undefined) {
            loop.markedAsPreliminary = [];
        }
        const markedAsPreliminaryElement = loop.markedAsPreliminary[loop.index - 1];
        if (markedAsPreliminaryElement === undefined) {
            loop.markedAsPreliminary[loop.index - 1] = false;
        }
        loop.markedAsPreliminary[loop.index - 1] = !loop.markedAsPreliminary[loop.index - 1];
        this.setState({loops: {...this.state.loops, [loopName]: loop}})
    }

    getIterationName = (loopName, iteration) => {
        const {globals, loops, currentFlowId, itemsStates} = this.state;
        const loopsDefinitions = flows[currentFlowId].loopsDefinitions;
        let shortName = getShortLoopName(loopName);
        const loop = loopsDefinitions[shortName];
        if (loop.hasOwnProperty('getIterationName')) {
            try {
                const iterationName = loop.getIterationName(globals, loops[loopName]["states"], iteration, loops, itemsStates);
                if (iterationName && iterationName.trim()) {
                    return iterationName.trim();
                }
            } catch (e) {
                return iteration;
            }
        }
        return iteration;
    }


    render() {

        const {
            hasGlobalError,
            globalErrorInfo,
            largeFont,
            hasErrors,
            showSummary,
            emailAddress,
            contractGenerated,
            contractError,
            contract,
            sessionCreated,
            globals,
            menuFixed,
            currentItemId,
            itemsStates,
            clientConnected,
            loops,
            path,
            currentFlowId,
            canFreelyNavigate,
        } = this.state;
        const currentItem = this.items[currentItemId];
        const topics = this.topics;
        const {loopName} = currentItem;
        let initialState = itemsStates[currentItem.id];
        let hasMoreIterations = true;
        let loop;
        let isLoopPreliminaryAllowed = false;
        let preliminarySection = false;
        let loopIndex = "";
        let allItems = [];
        let sectionName;
        let loopType;
        let showApplyToAll = false;
        if (!hasGlobalError) {
            if (loopName) {
                loop = loops[loopName];
                if (loop) {
                    const parentLoopName = getParentLoopName(loopName);
                    const markedAsPreliminaryArray = loops[parentLoopName].markedAsPreliminary;
                    if (markedAsPreliminaryArray === undefined) {
                        preliminarySection = false;
                    } else {
                        preliminarySection = markedAsPreliminaryArray[loops[parentLoopName].index - 1] || false;
                        sectionName = flows[currentFlowId].loopsDefinitions[parentLoopName]?.namePreliminarySection;
                    }
                    const shortLoopName = getShortLoopName(loopName);
                    const friendlyLoop = flows[currentFlowId].loopsDefinitions[shortLoopName];
                    loopType = friendlyLoop?.loopType;
                    if (friendlyLoop.hasOwnProperty('hasMoreIterations')) {
                        hasMoreIterations = friendlyLoop?.hasMoreIterations(itemsStates, globals, loops);
                    }

                    if (!sectionName) {
                        sectionName = friendlyLoop?.namePreliminarySection;
                    }
                    isLoopPreliminaryAllowed = friendlyLoop?.allowPreliminary;
                    loopIndex = loops[loopName].index;
                    initialState = loops[loopName].states[loopIndex - 1][currentItem.id];
                    if (initialState !== undefined && initialState.fields && !currentItem.fields) {
                        currentItem.fields = initialState.fields;
                    }
                    const firstRealIteration = loopIndex === 1 || isRealFirstIteration(loops[loopName], loopIndex);
                    showApplyToAll = currentItem.allowApplyAll && firstRealIteration && hasMoreIterations
                    if (this.hasIncompleteLoop) {
                        currentItem.errors = [{text: 'It is not possible to exit this section before all loop iterations are completed.'}];
                    }
                }
            }
            if (showSummary) {
                buildSummary(this.items, itemsStates, loopIndex, loopName, loops, allItems, globals, flows[currentFlowId].items[0].id);
            }
        }
        let autoJoin = false;
        if (!sessionCreated) {
            const query = new URLSearchParams(document.location.search.substring(1));
            const sessionIdPublicToJoin = query.get('view');
            if (sessionIdPublicToJoin) {
                autoJoin = sessionIdPublicToJoin;
            }
        }
        return (
            <div className={largeFont ? 'presentation' : undefined}>
                <style>{`
          html, body {
            background: #eee;
          }
          .string { color: green; }
            .number { color: darkorange; }
            .boolean { color: blue; }
            .null { color: magenta; }
            .key { color: orange; }
        `}</style>
                <div id={"content"}>
                    <CustomSockJsClient url={config.WS_URL} username={config.WS_USERNAME}
                                        password={config.WS_PASSWORD}
                                        topics={topics}
                                        ref={(client) => {
                                            this.clientRef = client
                                        }}
                                        onConnect={() => {
                                            this.setState({clientConnected: true});
                                            if (autoJoin) {
                                                this.joinSession({'sessionIdPublic': autoJoin});
                                            }
                                        }}
                                        onDisconnect={() => {
                                            this.setState({clientConnected: false})
                                        }}
                                        onUnhandledMessage={(e) => this.onUnhandledMessage(e)}
                                        debug
                    />
                    {flows[currentFlowId].disclaimerText &&
                    <DawidDisclaimer disclaimer={flows[currentFlowId].disclaimerText}/>}
                    <DawidHeader resetSession={() => this.reset()} logo={flows[currentFlowId].logo}
                                 width={WITH_CENTER_COLUMN}/>

                    {/* Attaching the top menu is a simple operation, we only switch `fixed` prop and add another style if it has
                gone beyond the scope of visibility
              */}
                    <Grid centered columns={1}>
                        <Grid.Column id="innerContent" width={WITH_CENTER_COLUMN}>


                            <Container fluid>

                                <DawidButtonsBar expiration={this.expiration} clientConnected={clientConnected}
                                                 sessionCreated={sessionCreated}
                                                 restoreStateFromLocalStorage={this.restoreStateFromLocalStorage.bind(this)}
                                                 createSession={this.createSession.bind(this)}
                                                 joinSession={this.joinSession.bind(this)}
                                                 sessionIdPublic={this.sessionIdPublic}
                                                 sessionIdPrivate={this.sessionIdPrivate}
                                                 exportState={this.exportState.bind(this)}
                                                 importState={this.importState.bind(this)}
                                                 mode={this.state.mode}
                                                 emailAddress={emailAddress}
                                                 deleteSession={this.deleteSession.bind(this)}
                                                 toggleLargeFont={() => this.setState({largeFont: !this.state.largeFont})}
                                                 submitEmail={(email) => this.setState({emailAddress: email}, this.persistState)}
                                />
                                <Visibility className={"no-print"}
                                            onBottomPassed={this.stickTopMenu}
                                            onBottomVisible={this.unStickTopMenu}
                                            once={false}
                                >


                                    <DawidMenu changeFlow={this.changeFlow}
                                               menuFixed={menuFixed}
                                               currentFlowId={currentFlowId}
                                               goSection={(section) => {
                                                   this.setState({showSummary: section === 'summary'})
                                               }}
                                               flows={flows}/>

                                </Visibility>

                                <Grid style={{clear: 'both', minHeight: '40vh'}}>
                                    <Grid.Row>
                                        {!showSummary && <Grid.Column width={4}>
                                            <FormPath onNavigate={this.onNavigate} path={path}
                                                      canFreelyNavigate={canFreelyNavigate}
                                                      currentItem={currentItem} items={this.items}/>
                                        </Grid.Column>}
                                        <Grid.Column id="mainContent" mobile={16} tablet={showSummary ? 16 : 12}
                                                     computer={showSummary ? 16 : 12}>
                                            {!showSummary && loop && <LoopsNavigation
                                                getIterationName={this.getIterationName.bind(this)} loops={loops}
                                                loopsDefinitions={flows[currentFlowId].loopsDefinitions}
                                                currentLoopName={loopName}
                                                onPageChange={this.handlePaginationLoopChange}
                                            />}
                                            {!showSummary && loop && isLoopPreliminaryAllowed &&
                                            <PreliminarySection marked={preliminarySection} sectionName={sectionName}
                                                                toggleSectionPreliminary={this.toggleSectionPreliminary.bind(this)}/>}
                                            <ItemErrorHandler>
                                                {!hasGlobalError && !showSummary && currentItem.id !== 'theEnd' &&
                                                <Item ref={this.itemRef} onChange={this.onItemValueChange}
                                                      onSubmit={this.onSubmit}
                                                      preliminarySection={preliminarySection}
                                                      onItemPreliminaryChange={this.onItemPreliminaryChange}
                                                      item={currentItem}
                                                      loopIndex={loopIndex}
                                                      isObserver={this.state.mode === 'observer'}
                                                      values={initialState?.values}
                                                      preliminaries={initialState?.preliminaries}
                                                      showApplyToAll={showApplyToAll}
                                                      applyToAll={initialState?.applyToAll}
                                                      hasErrors={hasErrors}
                                                      onApplyToAll={this.onApplyToAll}
                                                      loopType={loopType}
                                                      key={`c-${currentFlowId}-f-${currentItemId}-l-${loopIndex}`}

                                                />}
                                                {!hasGlobalError && showSummary && allItems.map((value, index) => {
                                                    return (value.currentItem.id !== 'theEnd' &&
                                                        <Item key={"item-" + index} onChange={this.onItemValueChange}
                                                              onSubmit={this.onSubmit}
                                                              item={value.currentItem}
                                                              loopIndex={value.loopIndex}
                                                              isObserver={this.state.mode === 'observer'}
                                                              values={value.initialState?.values}
                                                              preliminaries={value.initialState?.preliminaries}
                                                              hasErrors={hasErrors}
                                                              readOnly

                                                        />)
                                                })}
                                                {!hasGlobalError && currentItem.id === 'theEnd' &&
                                                <Contract generateContract={this.onGenerateContract}
                                                          contractGenerated={contractGenerated}
                                                          contract={contract}
                                                          contractError={contractError}

                                                />}
                                            </ItemErrorHandler>
                                            {
                                                hasGlobalError && <Form style={FORM_STYLE}>
                                                    <Label className={'background-orange'} size='large'
                                                           attached={'top'}>An unforeseen error occurred</Label>
                                                    <WarningMessage key={"errorGlobal"}
                                                                    header="An unforeseen error occurred"
                                                                    message={globalErrorInfo}/>
                                                </Form>
                                            }
                                        </Grid.Column>
                                    </Grid.Row>

                                </Grid>
                            </Container>
                        </Grid.Column>
                    </Grid>
                </div>
                <Footer/>
            </div>
        )
    }


}

